import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'SMS_MODEL_CONFIG_DETAIL',
        create: 'SMS_MODEL_CONFIG_CREATE',
        update: 'SMS_MODEL_CONFIG_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        default: this.market_id,
        label: this.$t('market_id'),
        show: false,
        col: {
          span: 16
        },
        // render: () => <d2-dict-select name="form_market_id" vModel={ this.form.model.market_id } custom />
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.market_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'sms_model_type',
        default: '',
        label: this.$t('sms_model_type'),
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "on": {
              "change": _this.onChange
            },
            "attrs": {
              "name": "sms_model_type"
            },
            "model": {
              value: _this.form.model.sms_model_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "sms_model_type", $$v);
              }
            }
          });
        }
      }, {
        prop: 'sms_model_status',
        default: '',
        label: this.$t('sms_model_status'),
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "sms_model_status",
              "button": true
            },
            "model": {
              value: _this.form.model.sms_model_status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "sms_model_status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'sms_model_content',
        default: '',
        label: this.$t('sms_model_content'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "type": "textarea",
              "autosize": true,
              "clearable": true
            },
            "model": {
              value: _this.form.model.sms_model_content,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "sms_model_content", $$v);
              }
            }
          });
        }
      }, {
        prop: 'ali_sms_config',
        default: '',
        label: this.$t('ali_sms_config'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "type": "textarea",
              "autosize": true,
              "clearable": true
            },
            "model": {
              value: _this.form.model.ali_sms_config,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "ali_sms_config", $$v);
              }
            }
          });
        }
      }, {
        default: '',
        label: this.$t("备注"),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("span", [_this.$t("新增带出来的是阿里云默认配置；如果定制短信模板，请先联系管理员，谢谢！")]);
        }
      }];
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    market_id: function market_id() {
      return this.$route.query.market_id;
    }
  },
  methods: {
    onChange: function onChange(res) {
      console.log(res, "000000");
      console.log(this);

      if (this.mode == "create") {
        if (res == 0) {
          this.form.model.sms_model_content = "[BWZN]verification code: [code], (thanks for using the smart cabinet service, the verification code is valid for [min] minutes)";
          this.form.model.ali_sms_config = "{\"user_key\":\"975476da21fc4b4e86a980549b7af4e6\",\"sign_name\":\"BWZN\"," + "\"user_code\":\"bw_03033bf2b11e4921ac2834ea588eb\",\"service_url\":\"https://sms.betterlockers.com/api/sms/send_sms_sign\"" + ",\"provider_key\":\"ali_o35wnie4e\",\"template_code\":\"SMS_219400526\",\"template_param\":{\"code\":null,\"min\":null}}";
        } else if (res == 1) {
          this.form.model.sms_model_content = "[BWZN]Pickup code [pick_code] Your parcel at [device_address] Tel:[save_user_phone]";
          this.form.model.ali_sms_config = "{\"user_key\":\"975476da21fc4b4e86a980549b7af4e6\",\"sign_name\":\"BWZN\",\"user_code\":\"bw_03033bf2b11e4921ac2834ea588eb\",\"service_url\":\"https://sms.betterlockers.com/api/sms/send_sms_sign\",\"provider_key\":\"ali_o35wnie4e\",\"template_code\":\"SMS_463653166\",\"template_param\":{\"pick_code\":null,\"save_user_phone\":null,\"device_address\":null}}";
        } else if (res == 4) {
          this.form.model.sms_model_content = "[BWZN]Your SMS balance [count]  is insufficient, please contact the administrator to recharge in time.";
          this.form.model.ali_sms_config = "{\"user_key\":\"975476da21fc4b4e86a980549b7af4e6\",\"sign_name\":\"BWZN\",\"user_code\":\"bw_03033bf2b11e4921ac2834ea588eb\"," + "\"service_url\":\"https://sms.betterlockers.com/api/sms/send_sms_sign\"," + "\"provider_key\":\"ali_o35wnie4e\",\"template_code\":\"SMS_471940088\",\"template_param\":{\"count\":null}}";
        } else {
          this.form.model.sms_model_content = "";
          this.form.model.ali_sms_config = "";
        }
      }
    }
  }
};